import React from 'react';
import { Box, Typography } from '@mui/material';
import type { ResponsiveStyleValue } from '@mui/system';

interface CrossedTextProps {
  text: string;
  fontSize?: ResponsiveStyleValue<string | number>;
  lineThickness?: string | number;
}

const defaultFontSize: ResponsiveStyleValue<string | number> = {
  xs: '1.75rem',
  sm: '2rem',
};

const CrossedText: React.FC<CrossedTextProps> = ({
  text,
  fontSize = defaultFontSize,
  lineThickness = '3px',
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-block',
        padding: 1,
      }}
    >
      <Typography
        variant='h3'
        sx={{
          fontWeight: 600,
          color: '#3a3a38',
          fontSize,
        }}
      >
        {text}
      </Typography>

      {/* Red Cross Overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        {/* Line 1 */}
        <Box
          sx={{
            width: '60%', // ⬅ smaller width
            height: lineThickness, // ⬅ thinner line
            bgcolor: 'red',
            position: 'absolute',
            transform: 'rotate(45deg)',
          }}
        />
        {/* Line 2 */}
        <Box
          sx={{
            width: '60%', // ⬅ smaller width
            height: lineThickness, // ⬅ thinner line
            bgcolor: 'red',
            position: 'absolute',
            transform: 'rotate(-45deg)',
          }}
        />
      </Box>
    </Box>
  );
};

export default CrossedText;
